import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import { ReactComponent as History } from '../../../assets/svg/History.svg'
import { ReactComponent as Analyze } from '../../../assets/svg/ButtonGraphIcon.svg'
import { emotions_color, emotions_heads, reasonsJson } from '../../../constants/Constants'
import { emotionLabel, format_day_only } from '../../../utils/util'

const FeedbackDayHeader = ({ emotion, studentFirstName, studentLastName, feedbackDay, studentUserId, isStudent, reasons, onOpenHistory }) => {
    const { t } = useTranslation()
    const emotionName = emotionLabel(t, emotion)

    return (
        <div className="feedback-modal-header" style={{ background: `${emotions_color[emotion]}85` }}>
            <div className="flex flex-row items-center">
                <div>
                    <img src={emotions_heads[emotion]} width={70} height={70} alt={emotionName} />
                </div>
                <div className="feedback-header-title">
                    <p>{studentFirstName} {studentLastName}</p>
                    {/* One string: the span is a flex container, so separate text nodes would lose the spacing around the dot. */}
                    <span>{emotionName ? `${emotionName} · ${format_day_only(feedbackDay)}` : format_day_only(feedbackDay)}</span>
                </div>
                <div className="flex-1"></div>
                <div className="flex flex-row gap-[10px] items-center">
                    <div className="feedback-history-button" onClick={onOpenHistory}>
                        <History />
                    </div>
                    {isStudent && (
                        <Link
                            to={`/analytics/student?id=${studentUserId}`}
                            className="bg-deepPurple rounded-full p-[10px] flex flex-row items-center gap-[10px]"
                            id="student-analytics-button"
                        >
                            <Analyze fill="white" />
                            <p className="text-white font-medium text-[16px] leading-5">{t('Analytics')}</p>
                        </Link>
                    )}
                </div>
            </div>
            {!!reasons && (
                <div className="mt-[11px] -mb-[6px] flex flex-row items-center">
                    <p className="text-[#5E639B] font-bold text-[18px] mr-[10px]">{t('Reasons')}:</p>
                    <div className="flex flex-row gap-[15px] items-center flex-1">
                        {reasons.map((reason, index) => (
                            <div key={index} className="flex flex-row">
                                {reasonsJson[reason.toLowerCase()]}
                                <span className="text-[#5E639B] uppercase font-semibold text-[16px] ml-[5px]">{t(reason?.toLowerCase())}</span>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    )
}

export default FeedbackDayHeader
